import {
  ADD_GLOBAL_SALE_GOODS,
} from '../../constants/Goods'

export default function GlobalSale (state = [], action) {
  if (action.type === ADD_GLOBAL_SALE_GOODS) {
    return [...action.payload];
  }
  return state;
}